import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { useGetPaymentSetupsQuery } from '../slices/paymentSetupsApiSlice';
export const useCreatorAccess = () => {
  const { userInfo } = useSelector(state => state.auth);
  const { data, isLoading, error } = useGetPaymentSetupsQuery(undefined, { refetchOnMountOrArgChange: true });
  const upgrades = !error && data?.creatorUpgradesEnabled === true;
  const tools = upgrades || (!error && Boolean(userInfo?._id && data?.teamUserId === userInfo._id));
  return { upgrades, tools, isLoading, error };
};
export default function CreatorAccessRoute({ upgrade = false }) {
  const access = useCreatorAccess();
  if (access.isLoading) return <p role="status">Loading account access...</p>;
  if (access.error) return <p role="alert">Could not check creator access. Please refresh the page.</p>;
  return (upgrade ? access.upgrades : access.tools) ? <Outlet /> : <Navigate to="/profile" replace />;
}
